import layoutManager from 'scoreboard/components/layout-manager'
import user from 'scoreboard/components/user'

function canCreateNotes(domainObjectModel) {
	if (layoutManager.sharedResource && user.isAnonymous()) {
		// #28323 - always show add buttons on shared dashboards if user is not logged in
		return true
	}
	// for metrics, both createPeriodNotes and createGlobalNotes must be true,
	// initiatives, only createGlobalNotes (#15125)
	else if (domainObjectModel.get('type') === 'metric') {
		return domainObjectModel.get('createPeriodNotes') && domainObjectModel.get('createGlobalNotes')
	} else {
		return domainObjectModel.get('createGlobalNotes')
	}
}

export default canCreateNotes

canCreateNotes.__filename__ = 'notes/can-create-notes.js'
